<template>
<div class="calendar-results">
    <div class="row">
        <div
            class="col-default-6 col-v-tablet-12"
            v-for="(item, index) in data"
            :key="index"
        >
            <calendar-card :data="item" :theme="theme"/>
        </div>
    </div>
</div>
</template>

<script>
import CalendarCard from './Card.vue'

export default {
    name: 'calendar-results',
    props: {
        theme: {
            type: String,
            default: 'upcoming',
            validator: prop => ['past', 'upcoming'].includes(prop)
        },
        data: {
            type: Array,
            default: () => []
        }
    },
    components: {
        CalendarCard
    }
}
</script>

<style lang="scss">
</style>
